/*
 * Style D 专用工具。
 * 这里的处理都源于线上接口实测，注释里标了对应的实证。
 */
import utils from './common'

const OSS_GAME_PIC = 'https://tikipay-static-resource.oss-cn-shenzhen.aliyuncs.com/tikiShop/gamePic/'
const OSS_PAY_CHANNEL = 'https://tikipay-static-resource-id.oss-ap-southeast-5.aliyuncs.com/seavoucher/pc/paychannel/'

export default {
  /*
   * 接口返回的 gamePic 存在带 \r\n 的脏数据（实测 id=51 Bleach Mobile 3D），
   * 不 trim 直接拼 URL 会 404。
   */
  gamePic(pic) {
    if (!pic) return ''
    return OSS_GAME_PIC + String(pic).trim()
  },

  payChannelPic(code) {
    if (!code) return ''
    return OSS_PAY_CHANNEL + String(code).trim() + '.png'
  },

  /*
   * topupOption 是整串（"56 Diamonds"），D 套面额卡要「大数字 + 小单位」两行。
   * 实测 id=45 的 27 档里有 1 档是 "Twilight Pass"，没有数字，
   * 匹配不到时降级成单行整串。
   */
  splitTopupOption(option) {
    const raw = String(option || '').trim()
    const m = raw.match(/^(\d[\d.,]*)\s+(.+)$/)
    if (!m) return { num: '', unit: raw, split: false }
    return { num: m[1], unit: m[2], split: true }
  },

  formatCurrency(currency, price) {
    if (price === '' || price === null || price === undefined) return ''
    const option = { style: 'currency', currency: currency, maximumFractionDigits: 2 }
    return Number(price).toLocaleString(utils.getLanguageByCurrency(currency), option)
  },

  isMobileUA() {
    return !!navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  },
}
